/* eslint-disable jsx-a11y/anchor-is-valid */
import styles from './InvoiceDetail.module.scss';
import http from 'config/http';
import { useQuery } from 'react-query';
import PageLoader from 'modules/shared/components/PageLoader/PageLoader';
import Topbar from 'modules/shared/components/Topbar/Topbar';
import BreadCrumb from 'modules/shared/components/BreadCrumb/BreadCrumb';
import { formatCurrency } from '../../../shared/utils/common';
import { Link, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { Collapse, CollapseBody, CollapseToggler } from 'modules/shared/components/Collapse';

const InvoiceDetail = () => {
    const { date } = useParams();
    const navigate = useNavigate();

    const billing = useSelector((state) => state.billing);

    const query = useQuery(['live-billing-invoice', date], async () => {
        const { data } = await http.get(`${process.env.REACT_APP_QUANTAM_API_URL}/live-unit-bills/invoices/${date}`);
        return data;
    });

    if (query.isLoading) return <PageLoader />;
    if (query.isError) return <div className="main-content">Failed to load invoice.</div>;
    if (!query.data) return null;

    const billingData = query.data;

    // prefer API currency if present, fallback to redux, fallback to empty/string
    const currency = billingData?.bill?.info?.currency || billing?.currency || '';

    const details = Array.isArray(billingData?.bill?.details) ? billingData.bill.details : [];

    // handle different API field names safely
    const totalAmount =
        billingData?.bill?.total_amount ??
        billingData?.bill?.totalAmount ??
        billingData?.bill?.total ??
        details.reduce((sum, r) => sum + (Number(r?.amount) || 0), 0);

    return (
        <>
            <Topbar showSearch={false} />

            <div className="main-content">
                <BreadCrumb
                    list={[
                        { label: 'Dashboard', to: '/' },
                        { label: 'Live Billing', to: '/live-billing' },
                        { label: moment(billingData.from_date, 'YYYYMMDD').format('MMMM YYYY') },
                    ]}
                />

                <h2 className="page-title">
                    <a className={[styles.backLink, 'me-3'].join(' ')} onClick={() => navigate('/live-billing')}>
                        <i className="fa fa-arrow-left"></i>
                    </a>{' '}
                    {moment(billingData.from_date, 'YYYYMMDD').format('MMMM YYYY')}
                </h2>

                <div className="card mb-4">
                    <div className="card-body">
                        <h4 className={styles.heading}>
                            Summary {moment(billingData.from_date, 'YYYYMMDD').format('MMM')}{' '}
                            {moment(billingData.from_date, 'YYYYMMDD').format('D')}
                            <span className="mx-1">-</span>
                            {moment(billingData.to_date, 'YYYYMMDD').format('D')}
                            {', '}
                            {moment(billingData.from_date, 'YYYYMMDD').format('YYYY')}
                        </h4>

                        <p className={[styles.meta, 'mb-4'].join(' ')}>
                            These charges are factored into your account balance.
                        </p>

                        <div className={styles.divider}></div>

                        {details.length > 0 ? (
                            <>
                                <Collapse>
                                    <CollapseToggler className={styles.table}>
                                        <div className={styles.tableRow}>
                                            <div className={styles.tableCell}>
                                                <div className="d-flex align-items-center">
                                                    <div className={styles.arrowIcon}>
                                                        <i className="fa fa-chevron-right"></i>
                                                    </div>
                                                    <div className={styles.tdTitle}>
                                                        Live Unit Usage ({details.length})
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={styles.tableCell}>
                                                <div className={styles.tdAmount}>
                                                    {formatCurrency(Number(totalAmount) || 0, currency)}
                                                </div>
                                            </div>
                                        </div>
                                    </CollapseToggler>

                                    <CollapseBody>
                                        <div className={styles.treeView}>
                                            <div className={styles.table}>
                                                {/* header row */}
                                                {/* <div className={styles.tableRow}>
                                                <div className={styles.tableCell}>
                                                    <div className={styles.tdTitle}>Unit</div>
                                                </div>
                                                <div className={styles.tableCell}>
                                                    <div className={styles.tdTitle}>Amount</div>
                                                </div>
                                            </div> */}

                                                {details.map((row, index) => {
                                                    const channels = Array.isArray(row.channels) ? row.channels : [];
                                                    const unitKey = row.qlive_unit || `${index}`;

                                                    return (
                                                        <div key={unitKey} className={styles.tableRow}>
                                                            <div>
                                                                <div className={styles.tableCellNoBottom}>
                                                                    <Link
                                                                        to={`/live-units/${row.qlive_unit}`}
                                                                        className={styles.link}
                                                                    >
                                                                        {row.qlive_unit}
                                                                    </Link>{' '}
                                                                    {channels.length > 0 ? `(${channels.length})` : ''}
                                                                </div>

                                                                {channels.length > 0 ? (
                                                                    <div className={[styles.treeView].join(' ')}>
                                                                        <div className={styles.channelTable}>
                                                                            {/* <div className={styles.tableRow}>
                                                                                <div className={styles.tableCell}>
                                                                                    <div className={styles.tableCell}>
                                                                                        Channel
                                                                                    </div>
                                                                                </div>
                                                                                <div className={styles.tableCell}>
                                                                                    <div className={styles.tableCell}>
                                                                                        Days
                                                                                    </div>
                                                                                </div>
                                                                                <div className={styles.tableCell}>
                                                                                    <div className={styles.tableCell}>
                                                                                        Amount
                                                                                    </div>
                                                                                </div>
                                                                            </div> */}

                                                                            {channels.map((ch, idx) => (
                                                                                <div
                                                                                    key={`${unitKey}-${ch.number}-${idx}`}
                                                                                    className={styles.tableRow}
                                                                                >
                                                                                    <div className={styles.tableCell}>
                                                                                        <div>Channel {ch.number}</div>
                                                                                    </div>

                                                                                    <div className={styles.tableCell}>
                                                                                        <div>
                                                                                            {ch.number_of_days} Day
                                                                                            {ch.number_of_days !==
                                                                                                1 && <span>s</span>}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className={styles.tableCell}>
                                                                                        <div
                                                                                            className={styles.tableCell}
                                                                                        >
                                                                                            {formatCurrency(
                                                                                                Number(ch.amount) || 0,
                                                                                                currency
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="mt-2 text-muted">
                                                                        No channel usage
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className={styles.tableCell}>
                                                                <div className={styles.tdAmount}>
                                                                    {formatCurrency(Number(row.amount) || 0, currency)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </CollapseBody>
                                </Collapse>

                                {/* Grand total (optional) */}
                                {/* <div className="row mt-3">
                                    <div className="offset-md-8 col-md-4">
                                        <div className={styles.divider}></div>
                                        <div className={styles.table}>
                                            <div className={styles.tableCell}>
                                                <div className={styles.tdTitle}>Total</div>
                                            </div>
                                            <div className={styles.tableCell}>
                                                <div className={styles.tdAmount}>
                                                    {formatCurrency(Number(totalAmount) || 0, currency)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </>
                        ) : (
                            <p>No Usage Log</p>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default InvoiceDetail;
